export const CONSTANTES = {
    FALLECIDO_ID: 13,
    MSJ_TITULO_ERROR : 'No hemos podido realizar esta acción',
    MSJ_TITULO_ERROR_2: 'No se pudo obtener los datos del paciente',
    MSJ_TITULO_ERROR_PAB : 'No hemos podido guardar la información de pabellón',
    MSJ_SUB_TITULO_ERROR : 'Vuelve a intentarlo. Si el problema persiste ponte en contacto con el administrador.',
    MSJ_TITULO_FALLECIDO : 'El RUT ingresado no puede ser utilizado para una admisión',
    MSJ_TITULO_NO_ENCONTRADO : 'El RUT o Pasaporte no se encuentra registrado en el sistema',
    MSJ_CONTENIDO_NO_ENCONTRADO : 'Verifique que el número de RUT o Pasaporte ingresado sea el correcto o ingrese una nueva persona.',
    MSJ_RESUMEN_ERROR: 'No se pudieron obtener los datos solicitados',
    MSJ_RUT:"El RUT ingresado corresponde a ",
    MSJ_RUT_FALLECIDO:" y el sistema indica que se encuentra fallecido",
    COTIZANTE_PACIENTE: 'Paciente',
    COTIZANTE_PACIENTE_ID: 1,
    SELECT_OPCION_DEFECTO: 'Selecciona opción',
    SIN_PREVISION: 0,
    PREVISION_PARTICULAR: 200,
    INDICADORES_GLOSA_PACIENTE_INSTITUCIONAL: 'paciente institucional',
    INDICADORES_GLOSA_SOCIO: 'socio',
    INDICADORES_GLOSA_TODO_ALEMANA: 'todo alemana',
    INDICADORES_GLOSA_ALEMANA_TOTAL: 'alemana total',
    INDICADORES_GLOSA_PLAN_PREFERENTE: 'plan preferente',
    PACIENTE_TIPO_INSTITUCIONAL: 1,
    PACIENTE_TIPO_PRIVADO: 2,
    MSJ_TITULO_NO_ROLES: 'No tiene privilegios para acceder',
    MSJ_TITULO_NO_ROLES_PERFILES: 'Error al consultar Roles y Perfiles',
    MSJ_CONTENIDO_NO_ROLES: 'Se cerrará la sesión',
    PAIS_CHILE:'chile',
    MSJ_RESPONSABLE_NO_ENCONTRADO: "El responsable del documento de respaldo debe estar registrado. ¿Quiere ingresar una nueva persona?",
    RELACION_OBLIGATORIA: "Debe seleccionar una relación con el paciente.",
    TELEFONO_OBLIGATORIO: "Debe ingresar un Teléfono Celular debido a que este paciente poseía un teléfono celular.",
    EMAIL_OBLIGATORIO: "Debe ingresar un Email debido a que este paciente poseía un Email.",
    FIJO_OBLIGATORIO: "Debe ingresar un Teléfono fijo debido a que este paciente poseía un teléfono fijo.",
    ERROR_INTEGRACION:"Ocurrio un error con integración cliente.",
    MSJ_ERROR_CAMPOS_FALTANTES:"Debe completar los campos faltantes para continuar",
    MSJ_ERROR_SERVICIO:"Problemas con cliente, contacte al administrador",
    MSJ_ERROR_SERVICIO_FASE2:"Problemas con Fase II, contacte al administrador",
    TITLE_PREVIOUS_INFO : '¿Desea mantener información entregada en admisión anterior?',
    MSJ_PREVIOUS_INFO : '¿Desea mantener información entregada en admisión anterior?',
};

export const CONST_AUTOADM = {
    TITULO_PASO2: 'Datos de tu atención',
    BAJADA_PASO2: 'Ahora completa la información de tu hospitalización para avanzar con tu check-in online',
    TIT_PABELLON_PASO2: 'Lo sentimos',
    MSJ_PABELLON_PASO2: 'No se encontró ningún pabellón agendado.',
    MSJ_UPDATE_INFO: 'Información actualizada exitosamente.',
    MSJ_NOTUPDATE_ERROR: 'No fue posible actualizar: ',
    MSJ_FORM_ERROR: 'Verifica la información ingresada ',
    MSJ_NOTFOUND_INFO: 'No se encontró información previa',
    MSJ_SEGUROS_COLECTIVOS: 'Ten en cuenta que, nosotros solo gestionamos seguros colectivos en convenio.',
    MSJ_INFO_SEGUROS_COLECTIVOS: 'Aplica para seguros en convenio, para coordinar el reembolso de hospitalización y luego informar el saldo final a pagar. Consulta con tu compañía si eres beneficiario.',
    LARGO_MAX_SEGURO_OTRO: 100,
    LARGO_MAX_SEGURO_OTRO_LEGACY: 30,
    PLACEHOLDER_SEGUROS: '¿Cuáles son tus seguros complementarios?',
    PLACEHOLDER_SEGURO_OTRO: '¿Cuál es el nombre de tu seguro?',
    HELPER_TEXT_SEGURO: 'Debes seleccionar al menos un seguro complementario.',
    HELPER_TEXT_SEGURO_OTRO: 'Debes ingresar el nombre de tu seguro. No dejes espacios al inicio o al final.',
    MSJ_LIMITE_CHECKIN:'Has alcanzado el máximo de 5 check-ins permitidos.',
    TITULO_PASO1: 'Revisa tus datos',
    BAJADA_PASO1: 'Para iniciar tu check-in de admisión online, verifica que tu información esté actualizada para que el proceso sea más rápido y simple',
    TITULO_PASO3: 'Datos de tu acompañante',
    BAJADA_PASO3: '¡Ya falta poco! Registra a la persona que te acompañará durante tu hospitalización; y si lo autorizas, podrá recibir información útil sobre tu cirugía, accesos asociados a tu estadía y otros datos relevantes para acompañarte en este momento',
    TITULO_RESPONSABLE_PAGARE: 'Responsable del pagaré y mandato',
    TITULO_INFO_PREVISIONAL: 'Información previsional',
    TITULAR_PREVISION: 'Por favor, ingresa los datos del titular de la previsión.',
    MSJ_SIN_CHECKINS: 'Aún no has realizado tu check-in online',
    BAJADA_SIN_CHECKINS: 'Completarlo con anticipación te ayudará a tener un ingreso más rápido y simple el día de tu procedimiento.',
    TITULO_ADJUNTA_CEDULA: 'Por último, adjunta el documento de identidad de quien firma',
    FORMATO_CEDULA: 'Formatos permitidos: jpg, jpeg, png, pdf y docx. Tamaño máximo permitido: 5 MB.',
    ERROR_FORMATO_CEDULA: 'El formato de los archivos no es válido y/o son demasiado grandes.',
    HELPER_TEXT_CELULAR: 'Debes ingresar un teléfono válido. Solo números y 9 dígitos',
    HELPER_TEXT_CORREO: 'Debes ingresar un email válido.',
    HELPER_TEXT_PREVISION: 'Debes seleccionar tu previsión.',
    HELPER_TEXT_PAIS: 'Debes seleccionar el país donde vives.',
    HELPER_TEXT_CIUDAD: 'Debes ingresar tu ciudad.',
    HELPER_TEXT_COMUNA: 'Debes seleccionar tu comuna.',
    HELPER_TEXT_DIRECCION: 'Recuerda ingresar tu dirección.',
    HELPER_TEXT_NOMBRE: 'Recuerda ingresar el nombre.',
    HELPER_TEXT_APELLIDO: 'Recuerda ingresar el apellido.',
    TITULO_SEGURO_COMPLEMENTARIO: 'Datos de tu seguro complementario',
    MSJE_ISAPRE_SIN_CONV_TITULO: 'Tu Isapre no tiene convenio para esta prestación.',
    MSJE_ISAPRE_SIN_CONV: 'Debes realizar el pago de forma particular y luego solicitar el reembolso según las condiciones de tu plan. Si tienes dudas, te recomendamos contactar directamente a tu previsión de salud.',
    MSJE_RESP_PAGARE_TITULO: 'Importante:',
    MSJE_RESP_PAGARE: 'el día de tu ingreso, una persona mayor de 18 años debe firmar el pagaré y presentar su cédula de identidad chilena vigente. Si la persona cuenta únicamente con pasaporte, te recomendamos contactarnos previamente en ',
    MSJE_RESP_PAGARE_EMAIL: 'pacienteinternacional@alemana.cl',
    MSJE_RESP_PAGARE_FIN: ' para orientarte sobre el proceso',
    HELPER_TEXT_NUMERO_DOCUMENTO: 'Recuerda ingresar el número de documento.',
    HELPER_TEXT_NUMERO_DOCUMENTO_ERROR: 'Formado documento número incorrecto',
    MODAL_AUTORIZ_TITULO: '¿Quieres mantener informado a tu acompañante?',
    MODAL_AUTORIZ_BAJADA_1: 'Si lo autorizas, podremos enviarle información útil sobre tu hospitalización, incluyendo el ',
    MODAL_AUTORIZ_BAJADA_1_BOLD: 'seguimiento de tu cirugía y accesos asociados a tu estadía.',
    MODAL_AUTORIZ_BAJADA_2: 'La información se compartirá exclusivamente con la persona que indiques y solo mientras no puedas recibirla directamente.',
    MODAL_AUTORIZ_BTN_SI: 'Sí, autorizo',
    MODAL_AUTORIZ_BTN_NO: 'No autorizo',
    MODAL_DOCS_EXITO_TITULO: '¡Todo listo!',
    MODAL_DOCS_EXITO_BAJADA: 'Tus archivos fueron recibidos y ya forman parte de tu check-in online.',
    MODAL_DOCS_EXITO_BTN: 'Entendido',
    MODAL_DOCS_ERROR_TITULO: '¡Lo sentimos!',
    MODAL_DOCS_DUPLICADO_TITULO: 'Archivo duplicado',
    MODAL_DOCS_DUPLICADO_BAJADA: 'Ya adjuntaste este archivo. Para continuar, selecciona un documento diferente.',
    MODAL_DOCS_ERROR_BTN: 'Entendido',
    PLACEHOLDER_DECLARACION_ACCIDENTE: 'Describe brevemente cómo ocurrió el accidente. Si tu ingreso no corresponde a un accidente, escribe: No corresponde a un accidente.',
    MSJE_ALERT_DECLARACION_ACCIDENTE: 'Una vez completada la información, guarda y descarga el documento. Deberás presentarlo el día de tu ingreso.',
    MSJE_DECLARACION_ACCIDENTE_CARD: 'Complétala y descárgala para presentarla el día de tu ingreso.',
    MSJE_GUARDAR_DECLARACION_OK: 'Declaración de accidente guardada exitosamente.',
    BTN_GUARDAR_DECLARACION: 'Guardar declaración',
    MSJE_ERROR_DECLARACION_ACCIDENTE: 'La descripción del accidente no puede superar 250 caracteres.',
    MSJE_ERROR_DECLARACION_ACCIDENTE_MIN: 'La descripción del accidente debe tener al menos 3 caracteres.',
    MSJE_ERROR_DECLARACION_ACCIDENTE_MAX: 'La descripción del accidente no puede superar 250 caracteres.',
    MSJE_ERROR_DECLARACION_ACCIDENTE_UNSAFE: 'La descripción del accidente contiene texto no permitido.',
    MSJE_ERROR_DECLARACION_ACCIDENTE_SIN_GUARDAR: 'Recuerda grabar la descripción de accidente',
    EYEBROW_BORRADOR_PAGARE: 'Pagaré y mandato',
    BADGE_BORRADOR_PAGARE: 'Borrador',
    TITULO_BORRADOR_PAGARE: 'Pagaré de hospitalización',
    MSJE_BORRADOR_PAGARE_CARD: 'Recomendamos revisarlo con anticipación para agilizar tu ingreso',
    BTN_VER_PDF_BORRADOR: 'Ver pdf',
    MODAL_PDF_BTN_DESCARGAR: 'Descargar',
    MODAL_PDF_BTN_CERRAR: 'Cerrar',
    MODAL_PDF_TITULO_DECLARACION: 'Declaración de accidente',
}

export const DEC_ACCIDENTE_ISAPRE = [
    {
        "codigo": "20",
        "glosa": "Banmédica S.A."
    },
    {
        "codigo": "40",
        "glosa": "Colmena Golden Cross S.A."
    },
    {
        "codigo": "50",
        "glosa": "Consalud S.A."
    },
    {
        "codigo": "110",
        "glosa": "Isapre CruzBlanca S.A."
    },
    {
        "codigo": "120",
        "glosa": "Nueva Masvida"
    },
    {
        "codigo": "190",
        "glosa": "Vida Tres S.A."
    },
    {
        "codigo": "10",
        "glosa": "Esencial S.A."
    }
];